import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "animate.css";
import "./App.css";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import OrderPage from "./pages/OrderPage";
import DetailedMenuPage from "./pages/DetailedMenuPage";
import CateringPage from "./pages/CateringPage";
import SiteLayout from "./components/SiteLayout";

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route
            path="/detailed-menu"
            element={<DetailedMenuPage />}
          />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/catering" element={<CateringPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
